// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-0027bf81].require > .el-input__inner {\r\n  border: red 1px solid;\n}\n.item[data-v-0027bf81] {\r\n  width: calc(100% - 30px)\n}\r\n", ""]);
// Exports
module.exports = exports;
